import Head from "next/head";
import EmailSignupBanner from "../components/EmailSignupBanner";
import Layout from "../components/Layout";
import { HoverCard, Text} from '@mantine/core'
import { MenuId } from "../components/Header";
import styles from './3d-models.module.scss'


import { GetServerSideProps } from "next";
import { getThreeDModels, getUserInformation } from "../lib/data";
import { DateTime } from "luxon";
import { RusAuthProps, RusContextProps, SubscriberLevel, ThreeDModel } from "../lib/definitions";
import { useEffect, useRef, useState } from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from "@fortawesome/sharp-solid-svg-icons";
import Link from "next/link";
import { useRouter } from "next/router";

type Data = {
  models : ThreeDModel[],
  dateProcessed: string
  }

export default function Models({data} : {data: Data} & RusAuthProps & RusContextProps)
{
    return(
        <>
        
        <Layout menuId={MenuId.online}>

  
  <Head>
      <title>3d artists&rsquo; models</title>
      <meta name="description" content="A collection of online 3D models, including skeletons, anatomical models and facial features"/>      
  </Head>
  <div className = {styles.mainContent}>
  <h1 className={styles.h1}>3D models</h1>
  {/*<JWHostedPlayer jwId='QpsHwmpS' autostart={true} controls={false} loop={true} mute={true}/>*/}
    <Text>We&rsquo;ve got a growing collection of 3D models you can use for reference, and to understand anatomy. To access the models, click on one of the images below.</Text>
  
  </div>

<div className={styles.list}>
      {data.models.map(x=> <Model key={x.slug} model={x}/>)}
      </div>

  <EmailSignupBanner/>
  </Layout>



        </>

    );
  }

function Model(props: {model: ThreeDModel})
{

  const [clientRender, setClientRender] = useState(false);
  const router=useRouter();

  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() =>
  {
    setClientRender(true);
  }
  ,[]);

  async function mouseEnter(e: React.MouseEvent)
  {

      if (videoRef.current)
      {

        await videoRef.current.play();

      }
  }

  function onClick(e: React.MouseEvent)
  {

    if (videoRef.current)
    {
      router.push('/3d-models/' + props.model.slug);
    }
  }

  async function mouseLeave(e: React.MouseEvent)
  {

      if (videoRef.current)
      {

          await videoRef.current.pause();
      }
  }

  let inner = <></>

  if (!props.model.accessible)
  {
    inner = <><div className={styles.lockedItem}><img className={styles.lockedImage} src={props.model.previewFilename}/>
    <div className={styles.padlock}>
      <HoverCard>
        <HoverCard.Target>
      <FontAwesomeIcon icon={faLock} size='2x' color="#c00"/>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Text size='sm'>3d models are only available to gold subscribers. Click <Link href='/subscription'>here</Link> to find out more.</Text>
      </HoverCard.Dropdown>
      </HoverCard>
      </div>
    </div>
  
    </>
  }
  else if (!clientRender)
  {
    inner = <div className={styles.item}><img className={styles.image} src={props.model.previewFilename}/> </div>
  }  
  else
  {
        inner =  <video loop muted playsInline poster={props.model.previewFilename} ref={videoRef} onMouseEnter={async (e) => {await mouseEnter(e)}} onMouseLeave={async(e) => {await mouseLeave(e)}}>
        <source src={props.model.previewVideo} type="video/mp4"/>
        </video>
  }

  return <div className={styles.item} onClick={onClick} >
    {inner}
  </div>
}

export const getServerSideProps : GetServerSideProps = async (context)=>
{
    let user = await getUserInformation(context.req);

    let list = await getThreeDModels();

    const accessible = (user.subscriber_level==SubscriberLevel.gold);

    list.forEach(x=>{
      x.accessible = (!x.subscriberOnly || accessible);
    });

    return {
      props: {
        data: 
        { 
            models:list,
            dateProcessed: DateTime.now().toISO()
        }
     }   

    }
}
